<template>
    <el-scrollbar class="reach-bottom-scroll" ref="reachBottomScroll">
        <slot></slot>
        <scroll-loading v-if="loading || !loaded"></scroll-loading>
        <no-more v-else-if="loaded && total" :text="endedText" :style="endedStyle"></no-more>
        <no-more v-else-if="loaded && !total" :text="emptyText" :style="emptyStyle"></no-more>
        <slot name="suffix"></slot>
    </el-scrollbar>
</template>

<script>
export default {
    props: {
        reachBottomDistance: {
            type: Number,
            default: 50
        },
        loading: {
            type: Boolean,
            required: true
        },
        loaded: {
            type: Boolean,
            required: true
        },
        total: {
            type: Number,
            default: 0
        },
        endedText: {
            type: String,
            default: ''
        },
        endedStyle: {
            type: Object,
            default(){
                return {}
            }
        },
        emptyText: {
            type: String,
            default: ''
        },
        emptyStyle: {
            type: Object,
            default(){
                return {}
            }
        }
    },
    mounted(){
        this.$refs.reachBottomScroll.wrap.addEventListener('scroll', this.scrollHandle)
    },
    beforeDestroy(){
        this.$refs.reachBottomScroll.wrap.removeEventListener('scroll', this.scrollHandle)
    },
    methods: {
        scrollHandle(e){
            if(e.target.scrollHeight - e.target.clientHeight - e.target.scrollTop <= this.reachBottomDistance){
                this.$emit('reach-bottom')
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.reach-bottom-scroll{
    height: 100%;
}
</style>


// WEBPACK FOOTER //
// src/components/ReachBottomScroll/index.vue